import type { UserData } from 'js/lib/user';

let userObject: UserData | {} | undefined;

declare const coursera: { user: UserData } | undefined;

if (typeof coursera === 'object' && coursera.user) {
  // TODO: type global coursera
  const userData = coursera.user as UserData;
  // We override is_superuser based on is_poweruser as a way to avoid
  // changing SU-based logic but sometimes we need to know the original
  // value, use is_superuser_strict for that
  userData.is_superuser_strict = userData.is_superuser;
  userData.is_superuser = userData.is_superuser || userData.is_poweruser;

  userObject = userData;
} else {
  // In the nodejs context coursera doesn't exist since it's injected
  // into the DOM on the client.
  userObject = {};
}

/**
 * @deprecated Please consider moving this to a more appropriate shared package like lib/user
 */
const userExport = userObject;

export default userExport;
